export default {
    companyTrendsOnly: 'Show only company-trends',
    trendoneTrendsOnly: 'Show only Trendone-trends',
    trendsWithUseCasesOnly: 'Show only trends with use cases'
}
